import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Paper, TextField } from '@mui/material';

// ============================================
// Container & Layout
// ============================================
export const PageContainer = styled(Box)({});

export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
});

export const PageTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 700,
  color: '#111',
  marginRight: '20px',
});

// ============================================
// Search & Filter Section
// ============================================
export const SearchSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const FilterSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '20px',
  flexWrap: 'wrap',
});

export const FilterItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const FilterLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#333',
  minWidth: '70px',
});

export const DateInputWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

// ============================================
// Buttons
// ============================================
export const ResetButton = styled(Button)({
  height: '40px',
  minWidth: '120px',
  backgroundColor: '#f5f5f5',
  color: '#666',
  fontSize: '14px',
  fontWeight: 500,
  border: '1px solid #ddd',
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
});

export const ExcelExportButton = styled(Button)({
  height: '36px',
  minWidth: '120px',
  backgroundColor: '#fff',
  color: '#0F7F85',
  fontSize: '13px',
  fontWeight: 500,
  border: '1px solid #0F7F85',
  '&:hover': {
    backgroundColor: '#f0f9f9',
  },
});

export const MonthNavButton = styled(Box)({
  width: '24px',
  height: '24px',
  padding: '5px',
  borderRadius: '5px',
  background: '#0F7F85',
  color: '#fff',
  border: '1px solid #0F7F85',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&:hover': {
    background: '#fff',
    color: '#0F7F85',
  },
});

export const TodayButton = styled(Button)({
  height: '36px',
  minWidth: '62px',
  color: '#fff',
  backgroundColor: '#0F7F85',
  border: '1px solid #0F7F85',
  borderRadius: '5px',
  fontSize: '13px',
  '&:hover': {
    backgroundColor: '#fff',
    color: '#0F7F85',
  },
});

// ============================================
// Table Styles
// ============================================
export const TableWrapper = styled(Box)({
  marginTop: '20px',
  border: '1px solid #ddd',
  borderRadius: '5px',
  overflow: 'hidden',
});

export const SummaryCard = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  padding: '20px',
  backgroundColor: '#f8fafb',
  borderRadius: '8px',
  marginBottom: '20px',
  border: '1px solid #e0e0e0',
});

export const SummaryItem = styled(Box)({
  textAlign: 'center',
});

export const SummaryLabel = styled(Typography)({
  fontSize: '13px',
  color: '#666',
  marginBottom: '4px',
});

export const SummaryValue = styled(Typography)({
  fontSize: '20px',
  fontWeight: 700,
  color: '#0F7F85',
});

// ============================================
// Status Chip
// ============================================
export const StatusChip = styled(Box)(({ status }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'ATTENDED':
      case 'COMPLETE':
        return { bg: '#e8f5e9', color: '#2e7d32' };
      case 'LATE':
        return { bg: '#fff3e0', color: '#ef6c00' };
      case 'WORKING':
        return { bg: '#e3f2fd', color: '#1976d2' };
      case 'ABSENT':
        return { bg: '#ffebee', color: '#c62828' };
      case 'EARLY_LEAVE':
        return { bg: '#fce4ec', color: '#ad1457' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };
  const colors = getStatusColor();
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 12px',
    borderRadius: '12px',
    backgroundColor: colors.bg,
    color: colors.color,
    fontSize: '12px',
    fontWeight: 500,
  };
});

// ============================================
// Pagination
// ============================================
export const PaginationWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
});

export const PaginationStyles = {
  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium': {
    background: '#0F7F85',
    border: 'none',
    height: '24px',
    minWidth: '24px',
  },
  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium.Mui-selected': {
    background: '#0F7F85',
    color: '#fff',
  },
  '.MuiPaginationItem-icon': {
    color: '#fff',
  },
};

// ============================================
// Divider
// ============================================
export const Divider = styled('hr')({
  border: '1px solid #e1e1e1',
  margin: '20px 0',
});

// ============================================
// Empty State
// ============================================
export const EmptyState = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 20px',
  color: '#999',
});

export const EmptyStateText = styled(Typography)({
  fontSize: '14px',
  color: '#999',
  marginTop: '12px',
});
